import {Component, OnInit} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { PeticionesHttpBackEndService } from '../../@core/mock/peticiones-http-backend.service';
import { UtilidadesService } from '../../@core/utils/utilidades.service';
import { NgbDateParserFormatter} from '@ng-bootstrap/ng-bootstrap';
import { NgbDateCustomParserFormatter} from '../../@theme/pipes/dateFormatPicker';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { FormBuilder } from '@angular/forms';

@Component({
  selector: 'ngx-aceptar-temas',
  templateUrl: './aceptar-temas.component.html',
  styleUrls: ['./aceptar-temas.component.scss'],
  providers: [UtilidadesService,PeticionesHttpBackEndService,NgbModalConfig, NgbModal,{provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter}]
})
export class AceptarTemasComponent implements OnInit {
 
  Token: any;
  infoTema:any;
  usuario:any;
  mensajeExito:any;
  mensajeExitoError:any;

  constructor(private datepip: DatePipe,private _route: ActivatedRoute, private utilidades: UtilidadesService,config: NgbModalConfig, private modalService: NgbModal, private _http : PeticionesHttpBackEndService, private DatePipe: DatePipe,public fb: FormBuilder,private router: Router) { 
    this.Token = JSON.parse(localStorage.getItem('auth_app_token'));
    this._route.queryParams.subscribe(params => {
      this.infoTema = params;
    });
    config.backdrop = 'static';
    config.keyboard = false;
    this.mensajeExito = "";
  }

  ngOnInit() {
    this.mensajeExito = "";
    this._http.getUsuario().subscribe(
      result => {
        this.usuario = result;
        if(this.usuario.Entidad._rol_id !== 1){
          this.router.navigate(['auth/login']);
        }
          this._http.getOneReg("v1/aprobarTemaForo",this.usuario.Entidad._entidad_id+"/"+this.infoTema.f+"/"+this.infoTema.d+"/"+this.infoTema.n+"/"+this.infoTema.e).subscribe(
            result => {
            let r:any = result;
            if(r.Code == 200){
              this.mensajeExito = r.Mensaje 
            }else{
              this.mensajeExitoError = r.Mensaje 
            }
          }
        );
  });
  }



  
}
